import { render } from "./ReturnLocationsList.vue?vue&type=template&id=3641bba3&scoped=true"
import script from "./ReturnLocationsList.vue?vue&type=script&lang=js"
export * from "./ReturnLocationsList.vue?vue&type=script&lang=js"

import exportComponent from "/home/adrianhardy/projects/Clients/O/Orchard_Crown_Ltd/ionic-storeroom/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3641bba3"]])

export default __exports__